/* eslint-disable import/prefer-default-export */
const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export async function sendEligibilityReviewAgentMessage({ message, token, threadId }) {
  window.dispatchEvent(new Event('api-activity'));
  const base = getEnv('REACT_APP_AGENTIC_API_BASE_URL') || '';
  const code = getEnv('REACT_APP_AGENTIC_API_CODE');
  const response = await fetch(`${base}/api/policy-compliance/chat?code=${code}`, {
    method: 'POST',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : undefined,
    },
    body: JSON.stringify({
      message,
      ...(threadId && { thread_id: threadId }),
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      errorText ||
        'Something went wrong while contacting the Eligibility Review Agent. Try again shortly.',
    );
  }

  return response.json();
}
